import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '@types';

interface AuthState {
  user: User | null;
  loading: boolean;
}

const initialState: AuthState = {
  user: null,
  loading: true,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload;
      state.loading = false;
    },
    setAuthLoadingStatus(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    logoutUser(state) {
      state.user = null;
    },
  },
});

export const { setAuthLoadingStatus, setUser, logoutUser } = authSlice.actions;
export default authSlice.reducer;
